import { useEffect, useState } from "react";

const cartKey = 'formBuilderCart';
const newItemsKey = 'newCartItems';


export default function useCart() {
    const [formBuilderCart, setFormBuilderCart] = useState([]);
    const [newCartItems, setNewCartItems] = useState([]);

    useEffect(() => {
        // try to restore from sessionStorage
        if (!formBuilderCart.length && sessionStorage.getItem(cartKey))
            setFormBuilderCart(sessionStorage.getItem(cartKey).split(','));
        if (!newCartItems.length && sessionStorage.getItem(newItemsKey))
            setNewCartItems(sessionStorage.getItem(newItemsKey).split(','));
    }, []);

    const addCartItems = (...items) => {
        if (!items.length)
            return;

        setFormBuilderCart(prevCart => {
            const newCart = [...prevCart];

            for (const item of items) {
                if (newCart.indexOf(item) === -1)
                    newCart.push(item);
            }

            sessionStorage.setItem(cartKey, newCart.join());

            return newCart;
        });

        setNewCartItems(items);
        sessionStorage.setItem(newItemsKey, items.join());
    };

    const removeCartItems = (...items) => {
        if (!items.length)
            return;

        setFormBuilderCart(prevCart => {
            const newCart = [...prevCart];

            for (const item of items) {
                if (newCart.indexOf(item) === -1)
                    continue;

                newCart.splice(newCart.indexOf(item), 1);
            }

            sessionStorage.setItem(cartKey, newCart.join());

            return newCart;
        })
    };

    const removeNewCartItems = () => {
        removeCartItems(...newCartItems);

        setNewCartItems([]);
        sessionStorage.removeItem(newItemsKey);
    }

    const clearCartItems = () => {
        setFormBuilderCart([]);
        setNewCartItems([]);

        sessionStorage.removeItem(cartKey);
        sessionStorage.removeItem(newItemsKey);
    };

    return {
        formBuilderCart,
        newCartItems,
        addCartItems,
        removeCartItems,
        removeNewCartItems,
        clearCartItems,
    };
}